// extracted by mini-css-extract-plugin
export default {"overlay":"MYyHJ3_O_APdSVyP4_Kt","fadeInAfterDelay":"UUc4lnqJhbHMJOgUH2YR"};